import React from "react";
import { AppProvider } from "@context/AppContext";

// Fonts

// Supports weights 100-900
import "@fontsource-variable/libre-franklin";
// Supports weights 400-800
import "@fontsource-variable/wix-madefor-display";

// Global styles
import "./src/styles/global.css";
import "./src/styles/cookies.css";

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);
